import { StyleContainer } from "./StyleContainer.js";

export default StyleContainer;
